import { Form, Input } from 'antd';
import Modal from 'antd/lib/modal/Modal';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { handleCreateHealthmetricType } from '../../fetchHooks/handleCreateHealthmetricType';
import type { HealthMetricType } from '../../fetchHooks/useHealthmetrictypesWithMeasurements';
import { ModalTitle } from '../MyDayPage/EditMyday';
import { ModalButtons } from '../MyDayPage/ModalButtons';

interface CreateHealthMetricModalProps {
  show: boolean;
  onCancel: () => void;
  onOk: () => void;
}
export const CreateHealthMetricModal = ({ show, onCancel, onOk }: CreateHealthMetricModalProps) => {
  const [form] = Form.useForm();
  const { t } = useTranslation();
  useEffect(() => {
    form?.resetFields();
  }, [form]);

  if (!show) return;

  return (
    <Modal
      open={show}
      style={{ minHeight: '50vh', padding: 0, borderRadius: '20px' }}
      onCancel={onCancel}
      footer={null}
      onOk={() => console.log('Validate Failed:')}
      forceRender
    >
      <ModalTitle title={t('healthMetric.createHealthMetricType')} />
      <Form
        form={form}
        name="create-healthmetrictype"
        initialValues={{ name: '', description: '', unit: '', ref_lower: '', ref_upper: '', comment: '' }}
        scrollToFirstError
      >
        <Form.Item
          name="name"
          label={<p>{t('healthMetric.name')}</p>}
          rules={[
            {
              required: true,
              message: t('healthMetric.pleaseInputName'),
            },
          ]}
        >
          <Input autoComplete="off" list="autocompleteOff" />
        </Form.Item>
        <Form.Item
          name="description"
          label={t('healthMetric.description')}
          rules={[
            {
              required: true,
              message: t('healthMetric.pleaseInputDescription'),
            },
          ]}
        >
          <Input.TextArea showCount maxLength={1000} autoComplete="off" />
        </Form.Item>
        <Form.Item
          name="unit"
          label={t('healthMetric.measurementUnit')}
          rules={[
            {
              required: true,
              message: t('healthMetric.pleaseInputUnit'),
            },
          ]}
        >
          <Input showCount maxLength={100} suffix="unit" autoComplete="off" />
        </Form.Item>
        <Form.Item
          name="ref_lower"
          label={t('healthMetric.referenceLow')}
          rules={[
            {
              message: t('healthMetric.pleaseInputReferenceLow'),
            },
          ]}
        >
          <Input type="number" />
        </Form.Item>
        <Form.Item
          name="ref_upper"
          label={t('healthMetric.referenceUpper')}
          rules={[
            {
              message: t('healthMetric.pleaseInputReferenceUpper'),
            },
          ]}
        >
          <Input type="number" />
        </Form.Item>

        <Form.Item name="comment" label={t('passwords.comment')}>
          <Input.TextArea showCount autoSize={{ minRows: 4, maxRows: 60 }} />
        </Form.Item>
        <ModalButtons
          onOk={() => {
            form
              .validateFields()
              .then((values) => {
                handleCreateHealthmetricType(values as HealthMetricType, () => {
                  onOk?.();
                });
                form.resetFields();
              })
              .catch((info) => {
                console.log('Validate Failed:', info);
              });
          }}
          onCancel={onCancel}
          okText={t('common.add')}
        />
      </Form>
    </Modal>
  );
};
